export default "__VITE_ASSET__IHXH9hKS__"